// Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./CarFooter"; // assicurati che il path sia corretto
import FooterBar from "./CarFooterbar"; // assicurati che il path sia corretto

const Layout = () => {
  return (
    <>
      {/* Il contenuto specifico della pagina verrà renderizzato qui */}
      <Outlet />
      <Footer />
      <FooterBar />
    </>
  );
};

export default Layout;
